import { useQuery } from "@tanstack/react-query";
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

// Mock function to replace the server action
const getAuthStatus = async () => {
  // This would need to be replaced with an API call
  // For now, just return success
  return { success: true };
};

const AuthCallbackPage = () => {
    const navigate = useNavigate();

    const { data } = useQuery({
        queryKey: ["auth-status"],
        queryFn: async () => await getAuthStatus(),
        retry: true,
        retryDelay: 500,
    });

    if (data?.success) {
        navigate("/dashboard");
    }

    return (
        <>
            <Helmet>
                <title>Verificando conta - MoovaTV</title>
                <meta name="description" content="Verificando sua conta MoovaTV." />
            </Helmet>
            
            <div className="flex items-center justify-center flex-col h-screen relative">
                <div className="border-[3px] border-neutral-800 rounded-full border-b-neutral-200 animate-loading w-8 h-8"></div>
                <p className="text-lg font-medium text-center mt-3">
                    Verificando sua conta no <span className="text-brand-sky">MoovaTV</span>...
                </p>
            </div>
        </>
    )
};

export default AuthCallbackPage;
